import { Fragment } from 'react';

import { Item, ItemContent, ItemTitle, ItemValue } from '@playbooks/molecules/items';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { buildArray } from '@playbooks/utils';

import type { SkeletonCountProps } from './types';

const ItemSkeleton = ({ count = 3, className = '' }: SkeletonCountProps) => (
	<Fragment>
		{buildArray(count).map((v, i) => (
			<Item key={i} className={className}>
				<ItemContent>
					<ItemTitle>{<Skeleton className='w-20' />}</ItemTitle>
				</ItemContent>
				<ItemValue format='text' value={<Skeleton className='w-10' />} />
			</Item>
		))}
	</Fragment>
);
export { ItemSkeleton };
